/* eslint-disable import/no-anonymous-default-export */
import Cookies from "js-cookie";
import {
    USER_LOGIN_REQUEST,
    USER_LOGIN_SUCCESS,
    USER_LOGIN_FAIL,
    RECEIVE_ACCESS_TOKEN,
    CLEAR_USER_INFO,
    TOKEN_RENEW_REQUEST,
    TOKEN_RENEW_SUCCESS,
    TOKEN_RENEW_FAIL,
    KB_USER_DATA,
    SET_ALL_USERS,
    SET_ROLE_LIST,
    GET_MODEL_HIERARCHY_REQUEST,
    GET_MODEL_HIERARCHY_SUCCESS,
    GET_MODEL_HIERARCHY_FAIL,
    DELETE_MODEL_HIERARCHY_REQUEST,
    DELETE_MODEL_HIERARCHY_SUCCESS,
    DELETE_MODEL_HIERARCHY_FAIL,
    UPDATE_MODEL_HIERARCHY_FAIL,
    UPDATE_MODEL_HIERARCHY_SUCCESS,
    UPDATE_MODEL_HIERARCHY_REQUEST,
    CREATE_MODEL_HIERARCHY_REQUEST,
    CREATE_MODEL_HIERARCHY_SUCCESS,
    CREATE_MODEL_HIERARCHY_FAIL,
    FILTER_MODELHRCY,
    CLEAR_MODELHRCY_FILTERS
} from "constants/userConstants";
import { applyFilters } from "pages/Utils/FilterUtil";

const defaultState = {
    loading: false,
    userInfo: Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : null,
    token: Cookies.get("token"),
    expiresAt: null,
    error: null,
    kbUser: null,
    allUsers: [],
    roleList: [],
    modelHierarchy: [],
    filters: {},
    filteredModelHrcy: [],

};

export default (state = defaultState, { type, payload }) => {
    switch (type) {
        case USER_LOGIN_REQUEST:
            return { loading: true };
        case USER_LOGIN_SUCCESS:
            return {
                loading: false,
                userInfo: payload.data,
                token: payload.token,
                error: null,
            };
        case KB_USER_DATA:

            return {
                ...state,
                kbUser: payload,
                userInfo: { ...state.userInfo, role: payload?.role },
            }
        case TOKEN_RENEW_SUCCESS:
            return {
                ...state,
                loading: false,
                token: payload,
            };
        case USER_LOGIN_FAIL:
            return {
                loading: false,
                userInfo: null,
                token: null,
                expiresAt: null,
                error: payload
            };
        case TOKEN_RENEW_FAIL:
            return {
                loading: false,
                userInfo: null,
                token: null,
                expiresAt: null,
                error: payload
            };
        case TOKEN_RENEW_REQUEST:
            return {
                loading: true,
                token: null,
                expiresAt: null
            };
        case RECEIVE_ACCESS_TOKEN:
            return {
                ...state,
                loading: false,
                userInfo: { ...payload.user, role: state?.kbUser?.role },
                token: payload.token,
                expiresAt: payload.expiresAt
            };
        case CLEAR_USER_INFO:
            return {
                userInfo: null,
                token: null,
                expiresAt: null,
                error: null
            };
        case SET_ALL_USERS:
            return {
                ...state,
                allUsers: payload
            }
        case SET_ROLE_LIST:
            const remodeledList = payload.map(item => ({ value: item.id, label: item.name }));
            return {
                ...state,
                roleList: remodeledList
            }

        case GET_MODEL_HIERARCHY_REQUEST:
            return {
                ...state,
                loading: true
            };
        case GET_MODEL_HIERARCHY_SUCCESS:
            const filteredModelHierarchy = applyFilters(Object.values(state.filters || {}), payload?.modelHrchyDetails);
            return {
                ...state,
                loading: false,
                modelHierarchy: payload,
                filteredModelHrcy: filteredModelHierarchy
            };
        case GET_MODEL_HIERARCHY_FAIL:
            return {
                ...state,
                loading: false,
                error: payload
            };

        case DELETE_MODEL_HIERARCHY_REQUEST:
            return {
                ...state,
                loading: true
            };
        case DELETE_MODEL_HIERARCHY_SUCCESS: {
            const { kmatId, region } = payload;
            const updatedModelHrchyDetails = Array.isArray(state.modelHierarchy?.modelHrchyDetails)
                ? state.modelHierarchy.modelHrchyDetails.filter(
                    item => !(item.kmatId === kmatId && item.region === region)
                )
                : [];
            return {
                ...state,
                loading: false,
                modelHierarchy: {
                    ...state.modelHierarchy,
                    modelHrchyDetails: updatedModelHrchyDetails
                }
            };
        }
        case DELETE_MODEL_HIERARCHY_FAIL:
            return {
                ...state,
                loading: false,
                error: payload
            };
        case UPDATE_MODEL_HIERARCHY_REQUEST:
            return {
                ...state,
                loading: true
            };
        case UPDATE_MODEL_HIERARCHY_SUCCESS: {
            const updatedItem = payload;
            const updatedModelHrchyDetails = Array.isArray(state.modelHierarchy?.modelHrchyDetails)
                ? state.modelHierarchy.modelHrchyDetails.map(item => {
                    if (item.kmatId === updatedItem.kmat_id && item.region === updatedItem.region) {
                        return {
                            ...item,
                            modelName: updatedItem.model_name,
                            category: updatedItem.category,
                            series: updatedItem.series,
                            subCategory: updatedItem.sub_category,
                            lastModBy: updatedItem.last_modified_by,
                            lastModifiedDate: updatedItem.last_modified_ts
                        };
                    }
                    return item;
                })
                : [];
            return {
                ...state,
                loading: false,
                modelHierarchy: {
                    ...state.modelHierarchy,
                    modelHrchyDetails: updatedModelHrchyDetails
                }
            };
        }
        case UPDATE_MODEL_HIERARCHY_FAIL:
            return {
                ...state,
                loading: false,
                error: payload
            };

        case CREATE_MODEL_HIERARCHY_REQUEST:
            return {
                ...state,
                loading: true
            };
        case CREATE_MODEL_HIERARCHY_SUCCESS:
            const newItem = {
                kmatId: payload.kmat_id,
                region: payload.region,
                modelName: payload.model_name,
                category: payload.category,
                series: payload.series,
                subCategory: payload.sub_category,
                lastModBy: payload.last_modified_by,
                lastModifiedDate: payload.last_modified_ts
            };
            return {
                ...state,
                loading: false,
                modelHierarchy: {
                    ...state.modelHierarchy,
                    modelHrchyDetails: [
                        newItem,
                        ...(Array.isArray(state.modelHierarchy?.modelHrchyDetails) ? state.modelHierarchy.modelHrchyDetails : [])
                    ]
                },
                filteredModelHrcy: [
                    newItem,
                    ...(Array.isArray(state.filteredModelHrcy) ? state.filteredModelHrcy : [])
                ]
            };
        case CREATE_MODEL_HIERARCHY_FAIL:
            return {
                ...state,
                loading: false,
                error: payload
            };
        case FILTER_MODELHRCY:
            const { name, searchText, matchFields, type } = payload;
            const filters = {
                ...state.filters,
                [name]: {
                    value: searchText,
                    type,
                    matchFields
                }
            }              
            const filteredModelHrcy = applyFilters(Object.values(filters || {}), state.modelHierarchy?.modelHrchyDetails);
            return{
                ...state,
                filters,
                filteredModelHrcy
            }
        case CLEAR_MODELHRCY_FILTERS: {
            return {
                ...state,
                filters: {},
                filteredModelHrcy: state.modelHierarchy?.modelHrchyDetails
                };
                }
        default:
            return state;
    }
}
